<template>
  <UISkeletonLoaderSPA />
</template>

<script lang="ts" setup>
import { useAuthStore } from '@manager/store/auth-store';
import UISkeletonLoaderSPA from 'shared/ui/registry/kinnovis/ui-skeleton-loaders/UISkeletonLoaderSPA.vue';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

const authStore = useAuthStore();
const route = useRoute();

onMounted(() => {
  const ssoError = route.query.ssoerror as string | undefined;
  authStore.login(ssoError);
});
</script>

<style scoped lang="scss"></style>
